import { Navigate, Outlet } from 'react-router-dom';
import { useAuthState } from '../../lib/partnerAuth';

export function AuthGuard() {
  const { user, loading } = useAuthState();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', color: 'var(--text-muted)' }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/partners/login" replace />;
  }

  return <Outlet />;
}
